import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import PageNotFound from "../views/PageNotFound";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    // component: Home,
    redirect: { name: "Login" },
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
    children: [
      {
        path: "",
        name: "Welcome",
        component: () => import("../views/Welcome.vue"),
      },
      {
        path: "configuration",
        component: () =>
          import(
            /* webpackChunkName: "configuration" */ "../views/Configuration.vue"
          ),
      },
      {
        path: ":company/class_documents",
        component: () =>
          import(
            /* webpackChunkName: "documents" */ "../views/ClassDocSearch.vue"
          ),
      },
      {
        path: ":company/class_search",
        component: () =>
          import(
            /* webpackChunkName: "documentHistory" */ "../views/ClassDocSearch.vue"
          ),
      },
      {
        path: ":company/class_einvoice_details",
        component: () =>
          import(
            /* webpackChunkName: "EInvoiceSearch" */ "../views/EInvoiceSearch.vue"
          ),
      },
      {
        path: ":company/class_upload",
        component: () =>
          import(/* webpackChunkName: "Upload" */ "../views/Upload.vue"),
      },
      {
        path: ":company/class_signature",
        component: () =>
          import(/* webpackChunkName: "Sign" */ "../views/Sign.vue"),
      },
      {
        path: ":company/change_pec_password",
        component: () =>
          import(
            /* webpackChunkName: "ChangePECPassword" */ "../views/ChangePECPassword.vue"
          ),
      },
      {
        path: ":company/signature",
        component: () =>
          import(/* webpackChunkName: "MultiSign" */ "../views/MultiSign.vue"),
      },
      {
        path: ":company/einvoice_status",
        component: () =>
          import(
            /* webpackChunkName: "EinvoiceStatus" */ "../views/EinvoiceStatus.vue"
          ),
      },
      {
        path: ":company/volumes_working",
        component: () =>
          import(/* webpackChunkName: "Volumes" */ "../views/Volumes.vue"),
      },
      {
        path: ":company/volumes_signed",
        component: () =>
          import(/* webpackChunkName: "Volumes" */ "../views/Volumes.vue"),
      },
      {
        path: "rc_signature",
        component: () =>
          import(/* webpackChunkName: "RC_Sign" */ "../views/Sign.vue"),
      },
      {
        path: ":company/search",
        component: () =>
          import(
            /* webpackChunkName: "GlobalSearch" */ "../views/GlobalSearch.vue"
          ),
      },
      {
        path: ":company/pdf_template",
        component: () =>
          import(
            /* webpackChunkName: "TemplateSearch" */ "../views/policies/TemplateSearch.vue"
          ),
      },
      {
        path: ":company/pdf_utils",
        component: () =>
          import(
            /* webpackChunkName: "TrimPdf" */ "../views/policies/TrimPdf.vue"
          ),
      },
      {
        path: ":company/class_policy_upload",
        component: () =>
          import(
            /* webpackChunkName: "UploadPolicy" */ "../views/policies/UploadPolicy.vue"
          ),
      },
      {
        path: ":company/policy_search",
        component: () =>
          import(
            /* webpackChunkName: "PolicySearch" */ "../views/policies/PolicySearch.vue"
          ),
      },
      {
        path: ":company/rao_new_user",
        component: () =>
          import(
            /* webpackChunkName: "PolicySearch" */ "../views/rao/NewUser.vue"
          ),
      },
      {
        path: ":company/rao_search_user",
        component: () =>
          import(
            /* webpackChunkName: "PolicySearch" */ "../views/rao/UserSearch.vue"
          ),
      },
      {
        path: ":company/policy_settings",
        component: () =>
          import(
            /* webpackChunkName: "PolicySearch" */ "../views/policies/Settings.vue"
          ),
      },
      {
        // generic path
        path: "*",
        component: PageNotFound,
      },
    ],
  },
  {
    path: "/validation",
    name: "Validation",
    component: () => import("../views/TESTROUTE.vue"),
  },
  {
    path: "/document-detail/:classId/:documentId",
    name: "DocumentDetail",
    component: () =>
      import(
        /* webpackChunkName: "documentDetail" */ "../components/DocumentDetail.vue"
      ),
    props: true,
  },
  { path: "*", component: PageNotFound },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login", "/register", "/validation"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("user");

  if (authRequired && !loggedIn) {
    return next({
      path: "/login",
      // query: { redirect: to.path },
    });
  }

  // Check for password change enforcement
  const passwordChangeRequired =
    store.getters["users/isPasswordChangeRequired"];
  const shouldBlockNavigation = store.getters["users/shouldBlockNavigation"];
  const isPasswordChangeInProgress =
    store.getters["users/isPasswordChangeInProgress"];

  // If password change is required and user is logged in
  if (loggedIn && passwordChangeRequired) {
    // Allow navigation to configuration page (password change page)
    if (to.path === "/dashboard/configuration") {
      return next();
    }

    // If password change is in progress, allow staying on configuration page
    if (
      isPasswordChangeInProgress &&
      from.path === "/dashboard/configuration"
    ) {
      return next();
    }

    // Block navigation away from password change when enforcement is active
    if (shouldBlockNavigation && from.path === "/dashboard/configuration") {
      // Prevent navigation away from password change page
      return next(false);
    }

    // If not on configuration page and password change is required, redirect there
    // But don't redirect if we're coming from the login page (to avoid circular redirects)
    if (to.path !== "/dashboard/configuration" && from.path !== "/login") {
      // Store the intended destination for after password change completion
      const currentContext = store.getters["users/getPasswordChangeContext"];
      if (currentContext && !currentContext.originalRedirection) {
        store.commit("users/setPasswordChangeRequired", {
          ...currentContext,
          originalRedirection: to.path,
        });
      }
      return next("/dashboard/configuration");
    }
  }

  // Normal navigation flow
  next();
});

// router.beforeEach((to, from, next) => {
//   if(to.matched.some(record => record.parent.name === 'Dashboard')) {
//     store.state.menu.data.classes
//   }
//   console.log(to);
//   next();
// });

export default router;
